import { render } from "./Index.vue?vue&type=template&id=88c2fdf6&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=88c2fdf6&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=88c2fdf6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-88c2fdf6"

export default script